var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.control.uniqueId,"name":_vm.control.name || _vm.control.uniqueId,"type":"checkbox"},on:{"change":function($event){return _vm.updateValue($event.target.checked)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }